import type { RefObject } from 'react'

import noop from 'lib/function/noop'
import { MapInteractionProvider, type MapInteractionContextValue } from '../contexts/MapInteractionContext'
import ChatContainer from '../containers/ChatContainer'

interface Props {
  chatId: number | undefined
  isLoggedIn: boolean
  isDevMode: boolean
  isSpoofed: boolean
  spoofingAgentEmail?: string
  navigateToNewChatRoute: () => void
  selectedBookingItemIds?: Array<string>
  onBookingItemsAdded?: (bookingItemIds: Array<string>) => void
  handleSubmit: (message: string) => Promise<void>
  handleMultiChoiceSelectionChange: (selection: Array<string>) => void
  activeMultiChoiceSelection: Array<string>
  mobileSelectionText: string | undefined
  offerContextTag: { label: string; offerId: string } | undefined
  handleRemoveTag: (tag: string) => void
  chatInputRef: RefObject<HTMLTextAreaElement | null>
}

const DEFAULT_SELECTED_BOOKING_ITEM_IDS: Array<string> = []

const MOBILE_MAP_INTERACTION_VALUE: MapInteractionContextValue = {
  onCardHover: noop,
  onMarkerHover: noop,
  highlightedMarkerId: undefined,
}

function TripChatMobileChatView({
  chatId,
  isLoggedIn,
  isDevMode,
  isSpoofed,
  spoofingAgentEmail,
  navigateToNewChatRoute,
  selectedBookingItemIds = DEFAULT_SELECTED_BOOKING_ITEM_IDS,
  onBookingItemsAdded,
  handleSubmit,
  handleMultiChoiceSelectionChange,
  activeMultiChoiceSelection,
  mobileSelectionText,
  offerContextTag,
  handleRemoveTag,
  chatInputRef,
}: Props) {
  return (
    <MapInteractionProvider value={MOBILE_MAP_INTERACTION_VALUE}>
      <ChatContainer
        chatId={chatId}
        isLoggedIn={isLoggedIn}
        isDevMode={isDevMode}
        isSpoofed={isSpoofed}
        spoofingAgentEmail={spoofingAgentEmail}
        navigateToNewChatRoute={navigateToNewChatRoute}
        handleSubmit={handleSubmit}
        handleMultiChoiceSelectionChange={handleMultiChoiceSelectionChange}
        activeMultiChoiceSelection={activeMultiChoiceSelection}
        mobileSelectionText={mobileSelectionText}
        offerContextTag={offerContextTag}
        handleRemoveTag={handleRemoveTag}
        selectedBookingItemIds={selectedBookingItemIds}
        onBookingItemsAdded={onBookingItemsAdded}
        chatInputRef={chatInputRef}
        autoFocusChatInput={false}
        compactDisclaimer
        enableMapActions={false}
        fitAvailableHeight
      />
    </MapInteractionProvider>
  )
}

export default TripChatMobileChatView
